<script setup>
import { cn } from "@/shared/lib/utils";
import Spinner from "@/shared/ui/spinner/Spinner.vue";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  loading: { type: Boolean, default: false },
  fixed: { type: Boolean, default: false },
});
</script>

<template>
  <div
    data-slot="table-container"
    :class="
      cn('relative w-full overflow-auto h-full', loading && 'min-h-[200px]')
    "
  >
    <!-- Loading overlay -->
    <div
      v-if="loading"
      class="absolute inset-0 z-10 flex items-center justify-center bg-background/60"
    >
      <Spinner size="md" />
    </div>
    <table
      data-slot="table"
      :class="
        cn(
          'w-full caption-bottom text-sm',
          props.fixed && 'table-fixed',
          props.class
        )
      "
    >
      <slot />
    </table>
  </div>
</template>
